module.exports = __webpack_public_path__ + "static/media/42C4F2B0-D114-4D0D-B592-A454EAF9F939.7cbe7fd1.png";